'use strict';

import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import assign from 'object-assign';
import AuthStore from './AuthStore';
import UserStore from './UserStore';
import {isEmpty} from 'lodash';
import NutritionPatternConstants from '../constants/NutritionPatternConstants';
import { getConfig, isProSide } from '../utils/Env';

const CHANGE_EVENT = 'change';

let _store = {
    nutritionPatterns: [],
    loaded: false,
    loading: false,
};

async function loadNutritionPatterns(params) {
    const { practice_type, capabilities = {} } = UserStore.getUser() || {};
    let query = {};

    // Consumer-side surfaces (signup, self-onboarding, lifestyle plan) always request Consumer-tagged
    // patterns so Patient and Fitness Client see the same list as a non-connected Consumer. The sort
    // ordering still differs by role via getConditionContext/CONDITION_PRIORITIES in utils/Conditions.js.
    // PRO-side keeps tag filtering by practice_type to enforce scope-of-practice (Fitness PRO cannot
    // prescribe medical nutrition therapy conditions).
    const isPro = isProSide();
    if (isPro) {
        query.tags = practice_type === 'fitness' ? 'Fitness' : 'Dietetics';
    } else {
        query.tags = 'Consumer';
    }

    if (!isEmpty(params)) {
        query = {...query, ...params};
    }

    const nutritionPatterns = await AuthStore.fetch({url: getConfig('users_api') + '/nutrition-patterns', query}, null, true, true);

    if (!capabilities.premium_conditions && nutritionPatterns.elements) {
        _store.nutritionPatterns = nutritionPatterns.elements.filter(p => !p.tags?.includes('Premium'));
        return;
    }

    _store.nutritionPatterns = nutritionPatterns.elements || [];
}

var NutritionPatternStore = assign({}, EventEmitter.prototype, {
    getNutritionPatterns: function () {
        return _store.nutritionPatterns || [];
    },

    isLoaded: function () {
        return _store.loaded || false;
    },

    isLoading: function () {
        return _store.loading || false;
    },

    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },

    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    },

    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
});

export default NutritionPatternStore;

AppDispatcher.register((payload) => {
    const { actionType, params } = payload.action;

    switch (actionType) {
        case NutritionPatternConstants.NUTRITION_PATTERN_LOAD:
            if (_store.loaded || _store.loading) {
                return;
            }
            _store.loading = true;
            NutritionPatternStore.emitChange();
            loadNutritionPatterns(params).then(() => {
                _store.loading = false;
                _store.loaded = true;
                NutritionPatternStore.emitChange();
            });
            break;

        case NutritionPatternConstants.NUTRITION_PATTERN_RELOAD:
            _store.loading = true;
            NutritionPatternStore.emitChange();
            loadNutritionPatterns(params).then(() => {
                _store.loading = false;
                _store.loaded = true;
                NutritionPatternStore.emitChange();
            });
            break;
    }
});
